import React from 'react';
import './media-item-view.scss';
import { TouchableOpacity } from '../../common';
import { SVGS } from '../../assets';
import { FileUploadOutput } from '@zonofi/common/types/interface';

interface MediaItemViewProps {
  media: FileUploadOutput;
  onThreeDotPress?: (media: FileUploadOutput) => void;
  className?: string;
  leftIcon?: string;
  onMediaPress?: (media: FileUploadOutput) => void;
  isDisable?: boolean;
}

export const MediaItemView: React.FC<MediaItemViewProps> = ({
  media,
  onThreeDotPress,
  className = '',
  leftIcon = SVGS.CheckGreen,
  onMediaPress,
  isDisable = false,
}) => {
  return (
    <TouchableOpacity
      key={media.lastModified}
      className={`media-main-view ${className}`}
      onPress={() => onMediaPress?.(media)}
      disabled={isDisable}
    >
      <div className="media-main-view--left">
        <img src={leftIcon} alt="check icon" />
        <span className="media-main-view--text font-regular">{media.name}</span>
      </div>
      <TouchableOpacity
        className="media-main-view--dot"
        onPress={(e) => {
          e.stopPropagation();
          onThreeDotPress?.(media);
        }}
      >
        <img src={SVGS.ThreeDot} alt="menu" />
      </TouchableOpacity>
    </TouchableOpacity>
  );
};
